(function () {
  'use strict';

  /* Clicks are delegated from the document rather than bound per button, so the CTA
     works no matter when this bundle runs relative to the section markup, and keeps
     working if the section is re-rendered (theme editor, section morphing). */
  document.addEventListener('click', function (event) {
    if (!event.target || !event.target.closest) return;

    var btn = event.target.closest('[data-knn-fcta-btn]');
    if (!btn) return;

    var root = btn.closest('[data-knn-fcta]');
    var offerAtc = getOfferAtc();

    /* No offer widget on the page (or the merchant chose "scroll") — take the
       shopper to the selector instead of guessing a variant for them. */
    if (!root || root.dataset.action === 'scroll_to_offer' || !offerAtc) {
      scrollToOffer();
      return;
    }

    addViaOfferWidget(btn, offerAtc);
  });

  function init(scope) {
    (scope || document).querySelectorAll('[data-knn-fcta]').forEach(function (root) {
      if (root.dataset.knnFctaReady === 'true') return;
      root.dataset.knnFctaReady = 'true';

      trackHeight(root.querySelector('[data-knn-fcta-bar]'));
      trackVisibility(root);
    });
  }

  init();
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });

  /* Publish the real bar height so the footer spacer and scroll offset always clear
     it, however the title wraps or whatever the Stamped badge renders. */
  function trackHeight(bar) {
    if (!bar || typeof ResizeObserver !== 'function') return;

    new ResizeObserver(function (entries) {
      var entry = entries[0];
      if (!entry) return;
      document.documentElement.style.setProperty(
        '--knn-fcta-height', entry.target.offsetHeight + 'px'
      );
    }).observe(bar);
  }

  /* Reveal at community feedback on every screen size, and hide again when
     scrolling back above it. Keep it visible through the footer. An offer below the viewport
     must never trigger the bar on initial mobile load. */
  function trackVisibility(root) {
    if (!root.classList.contains('knn-fcta--auto')) return;

    var feedback = document.querySelector('.knn-review-slider__header');
    var trigger = feedback || getOfferTarget();
    if (!trigger) return;

    var apply = function () {
      var viewportHeight = window.innerHeight;
      var rect = trigger.getBoundingClientRect();
      /* Templates without feedback fall back to passing the offer, not merely
         having the offer outside the viewport in either direction. */
      var reached = feedback ? rect.top < viewportHeight : rect.bottom <= 0;
      root.dataset.stuck = reached ? 'true' : 'false';
    };

    if (typeof IntersectionObserver === 'function') {
      var observer = new IntersectionObserver(apply);
      observer.observe(trigger);
    } else {
      /* Capture also handles themes that scroll inside a page wrapper. */
      document.addEventListener('scroll', apply, { passive: true, capture: true });
    }
    window.addEventListener('resize', apply);

    apply();
  }

  /* The KNN Product Offer block owns variant resolution, sold-out handling, error
     reporting and the mini-cart handoff. Rather than duplicate any of that, drive
     its own add-to-cart button and mirror its busy state onto this one. */
  function addViaOfferWidget(btn, source) {
    if (source.disabled) return;   /* a request is already in flight */

    var label = btn.querySelector('[data-knn-fcta-label]') || btn;
    var addText = btn.getAttribute('data-add-text') || label.textContent;
    var loadingText = btn.getAttribute('data-loading-text') || 'Adding...';

    btn.disabled = true;
    label.textContent = loadingText;

    var reset = function () {
      btn.disabled = false;
      label.textContent = addText;
    };

    /* The offer widget re-enables its button once the fetch settles, pass or fail. */
    var observer = new MutationObserver(function () {
      if (source.disabled) return;
      observer.disconnect();
      clearTimeout(fallback);
      reset();
    });
    observer.observe(source, { attributes: true, attributeFilter: ['disabled'] });

    var fallback = setTimeout(function () {
      observer.disconnect();
      reset();
    }, 10000);

    source.click();
  }

  function getOfferAtc() {
    var widget = document.querySelector('[data-knn-offer]');
    return widget ? widget.querySelector('[data-knn-offer-atc]') : null;
  }

  function getOfferTarget() {
    return (
      document.querySelector('[data-knn-offer]') ||
      document.querySelector('.buy-buttons-block') ||
      document.querySelector('product-form')
    );
  }

  /* Walks the shopper back up to the offer selector.
     Deliberately scrollIntoView + scroll-margin rather than window.scrollTo with
     hand-computed coordinates: window.scrollTo silently does nothing when the page
     scrolls inside a container instead of the document (Horizon does exactly that on
     any page carrying .page-wrapper), whereas scrollIntoView always drives whichever
     element is the real scroller. scroll-margin then lets the browser account for the
     sticky header and this bar, so no manual offset maths is needed either. */
  function scrollToOffer() {
    var target = getOfferTarget();
    if (!target) return;

    var headerOffset = stickyHeaderHeight() + 16;
    var barHeight =
      parseInt(getComputedStyle(document.documentElement).getPropertyValue('--knn-fcta-height'), 10) || 0;

    target.style.scrollMarginTop = headerOffset + 'px';
    target.style.scrollMarginBottom = barHeight + 16 + 'px';

    /* Centre the widget when it fits in the band between header and bar; otherwise
       pin its top under the header so the tier list — not the trust row — lands in view. */
    var clearance = window.innerHeight - headerOffset - barHeight;
    var fits = target.getBoundingClientRect().height < clearance;

    target.scrollIntoView({
      behavior: prefersReducedMotion() ? 'auto' : 'smooth',
      block: fits ? 'center' : 'start'
    });

    /* Take keyboard focus along with the scroll, without fighting it. */
    var focusable = target.querySelector('[data-tier]:checked') || target.querySelector('[data-tier]');
    if (focusable) focusable.focus({ preventScroll: true });
  }

  /* 0 unless the header is actually pinned — it is only sticky at some breakpoints
     and only when the merchant enabled it. */
  function stickyHeaderHeight() {
    var header = document.querySelector('.header-section') || document.querySelector('#header-component');
    if (!header) return 0;

    var position = getComputedStyle(header).position;
    if (position !== 'sticky' && position !== 'fixed') return 0;

    return header.getBoundingClientRect().height;
  }

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }
})();
